//PageSeo：每個公開頁面拿來覆寫 <title> / <meta description> / OG。
//  React 19 支援把 <title> / <meta> / <link> 從元件樹自動 hoist 到 <head>，不需要 helmet 庫。
//  使用：在 page component 最頂層放 <PageSeo title="..." description="..." path="/love-enter" />
//
//  注意：SPA 切頁是 client-side，更換 title 在使用者瀏覽時即時生效；
//        對 Googlebot 而言，要等 JS render 完才看得到，因此 index.html 的預設 title
//        仍要對首頁友善，這支元件主要服務「使用者體驗 + Googlebot 二次 render」這兩個情境。

const SITE = "元辰雲閣";
const BASE_URL = "https://yuanchen.leinotek.com";
const DEFAULT_OG_IMAGE = `${BASE_URL}/images/ic-small-yuanchen-logo.png`;

const PageSeo = ({
  title,
  description,
  path = "",
  ogImage = DEFAULT_OG_IMAGE,
}) => {
  //title 自動補上品牌名後綴；如果 caller 給的 title 已含 SITE，就不重複貼
  const fullTitle =
    title && !title.includes(SITE) ? `${title}｜${SITE}` : title || SITE;
  const canonicalUrl = `${BASE_URL}${path || "/"}`;

  return (
    <>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonicalUrl} />
      {/* Open Graph 覆寫，讓社群分享預覽會配合該頁主題 */}
      <meta property="og:title" content={fullTitle} />
      {description && (
        <meta property="og:description" content={description} />
      )}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={fullTitle} />
      {description && (
        <meta name="twitter:description" content={description} />
      )}
      <meta name="twitter:image" content={ogImage} />
    </>
  );
};

export default PageSeo;
